import React from 'react'


const CheckEnabled = ({ title = 'Деактивировать', className = '', size, variant, rotate = false, onClick }) => {
    return (
        <i className={ `${className} spp-svg ${variant ? 'spp-svg-color-' + variant : ''} ${size ? 'spp-svg-size-' + size : ''} ${rotate === true ? 'rotate' : ''}` } onClick={ onClick }>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4.233 4.233">
                <title>{ title }</title>
                <g transform="scale(.26458)" data-name="Rectangle 6237" fill="none" stroke="none"><rect width="16" height="16" rx="2" /><path d="M2 0C.9 0 0 .9 0 2v12c0 1.098.9 2 2 2h12a2.01 2.01 0 002-2V2c0-1.1-.902-2-2-2H2zm0 1h12A.989.989 0 0115 2v12A.99.99 0 0113.999 15H2c-.562 0-1-.44-1-1.002V2c0-.562.438-1 1-1zm10.339 3.552a.498.498 0 00-.353.147L6.51 10.173 4.037 7.7a.499.499 0 10-.707.707l2.828 2.828a.499.499 0 00.707 0c.03-.03.047-.067.068-.102.036-.02.073-.038.104-.068l5.656-5.658a.499.499 0 00-.354-.854z" color="#000" fontWeight="400" fontFamily="sans-serif" overflow="visible" fill="#ff3347" /></g></svg>
        </i>
    )
}

export default CheckEnabled